import {
  CompositeFilterDescriptor,
  FilterDescriptor,
  State,
} from '@progress/kendo-data-query';
import { OBaseModel } from '@olameter/o-utilities';
import { View } from 'src/app/proto/generated/inv_view_message_pb';
import { InvStatusWebName } from 'src/app/shared/constants/invStatusOptions';
import { ColumnSettings } from '../ui/column-settings.model';

const columnConfigsConst = 'columnConfigs';
const gridStateConst = 'gridState';

export class ViewResponseModel implements OBaseModel {
  name: string;
  userName: string;
  title: string;
  contractName: string;
  contractTitle: string;
  gridNColumnState: string;
  isDefault: boolean;
  lastSeen?: Date;

  ColumnsConfig?: ColumnSettings[];
  GridState?: State;
  InvStatus?: FilterDescriptor;

  public static Mapper(reference: View): ViewResponseModel {
    const vrModel: ViewResponseModel = {
      title: reference.getTitle(),
      userName: reference.getUserName(),
      name: reference.getName(),
      contractName: reference.getContractName(),
      contractTitle: reference.getContractTitle(),
      gridNColumnState: reference.getGridState(),
      isDefault: reference.getIsDefault(),
      lastSeen: reference.getLastSeen()?.toDate(),
      InvStatus: null,
    };

    const allObj = Object.assign([], JSON.parse(vrModel.gridNColumnState));
    vrModel.ColumnsConfig = allObj[columnConfigsConst].filter((x) => x != null);
    vrModel.GridState = allObj[gridStateConst];

    const filters: any = vrModel?.GridState?.filter || { filters: [] };
    const index = filters.filters?.findIndex(
      (x) => x.field == InvStatusWebName.Field
    );

    if (index > -1) {
      vrModel.InvStatus = filters.filters.splice(index, 1)[0];
    }

    return vrModel;
  }

  public static MapperList(references: View[]): ViewResponseModel[] {
    const ret: ViewResponseModel[] = [];
    references?.forEach((reference) => {
      ret.push(ViewResponseModel.Mapper(reference));
    });
    return ret;
  }

  public static MapperToMessage(model: ViewResponseModel): View {
    const request = new View();
    request.setName(model.name);
    request.setUserName(model.userName);
    request.setTitle(model.title);
    request.setContractName(model.contractName);
    request.setContractTitle(model.contractTitle);
    request.setActive(true);

    const gridState = JSON.parse(JSON.stringify(model.GridState));

    if (model.InvStatus != null) {
      if (gridState.filter == null) {
        const filter: CompositeFilterDescriptor = {
          filters: [],
          logic: 'and',
        };

        gridState.filter = filter;
      }

      gridState.filter.filters.push(model.InvStatus);
    }

    let viewState: string =
      '{ "' + columnConfigsConst + '": ' + JSON.stringify(model.ColumnsConfig) + ',';
    viewState += ' "' + gridStateConst + '": ' + JSON.stringify(gridState);
    viewState += '}';

    request.setGridState(viewState);
    return request;
  }

  public static MapperWoStatusToFilter(model: any[]): FilterDescriptor {
    const values = [];

    model.forEach((f) => {
      if (f.active) {
        values.push(f.value);
      }
    });

    const filter: FilterDescriptor = {
      field: InvStatusWebName.Field,
      operator: 'eq',
      value: values,
    };

    return filter;
  }
}
